import React from 'react';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth' });
};

const Banner = ({ backgroundImg, backgroundAltText, title, subtitle, desc }) => {
  const backgroundStyle = {
    backgroundImage: `url(${backgroundImg})`,
  };

  return (
    <section id="banner" className='section'>
      <div
        className='background-holder'
        role="img"
        aria-label={backgroundAltText}
        style={backgroundStyle}
      >
        <span class="sr-only">{backgroundAltText}</span>
      </div>
      <div className='container boxed'>
        <div className='row'>
          <div className='col col-60 left'>
            <div className='content-holder'>
              <h1 className='title' dangerouslySetInnerHTML={{ __html: title }} />
              {subtitle && <h3 className='subtitle'>{subtitle}</h3>}
              {desc && <p className='desc'>{desc}</p>}
            </div>
            <div className='btn-holder'>
              <button onClick={() => scrollTo('product-full-home')} className='btn btn-primary'>Install Whole-Home Filtration</button>
              <button onClick={() => scrollTo('product-ro')} className='btn btn-primary'>Install Under-Sink Water Filtration</button>
            </div>
          </div>
          <div className='col col-40 right'></div>
        </div>
      </div>
    </section>
  );
};

export default Banner;